import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: '[speedmaps-horses-list]',
	templateUrl: './speedmaps-horses-list.component.html',
	styleUrls: ['./speedmaps-horses-list.component.scss'],
})
export class SpeedmapsHorsesListComponent implements OnInit {
	@Input() user: any;
	@Input() speed_maps_horses: any;
	@Input() form_guide_horses: any;
	@Input() bb_count: any;

	@Output() getSpeedMapsRaceHorseDetailsIn = new EventEmitter<{ e: object; horseId: any; i: any }>();
	@Output() openBlackbookIn: EventEmitter<boolean> = new EventEmitter<boolean>(false);

	constructor() {}

	ngOnInit(): void {}

	formatSubtitle = (percent: number) => {
		return percent;
	};

	onImgError(event: any, seq_no: any) {
		event.target.src = 'assets/images/jockeys/jockey' + seq_no + '.png';
		//Do other stuff with the event.target
	}

	percentToColor(percent: number, min: number, max: number): string {
		if (percent < 54) {
			return '#FF0000';
		} else if (percent >= 55 && percent <= 74) {
			return '#F5C61C';
		} else if (percent > 75) {
			return '#67BE53';
		}
		return '#67BE53';
	}

	OpenBlackbook(horse: any) {
		this.openBlackbookIn.emit(horse);
	}

	getRaceHorseDetailsInner($event: any) {
		this.getSpeedMapsRaceHorseDetailsIn.emit($event);
	}
}
